import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseToast } from './PurchaseToast';
export function Hero() {
  return <section className="relative min-h-fit bg-transparent text-slate-900 flex flex-col items-center justify-start md:justify-center px-4 pt-4 md:pt-12 pb-2 md:pb-4 overflow-hidden font-sans" data-id="element-99">
      {/* Brand Header */}
      <div className="flex items-center gap-2 mb-1 md:mb-6" data-id="element-100">
        <span className="text-blue-600 font-black tracking-widest text-sm md:text-sm uppercase" data-id="element-101">
          GUIADIGITAL360 TM
        </span>
      </div>

      {/* Main Title */}
      <h1 className="md:text-7xl lg:text-8xl font-black text-center max-w-5xl mb-2 md:mb-8 text-[32px]" data-id="element-102">
        El año escolar de química, organizado y listo para enseñar. <br data-id="element-103" />
        <span className="text-blue-600 md:text-[32px] block mt-2 text-[16px]" data-id="element-104">
          Cuadernillos completos, más de 150 fichas visuales y más de 200
          actividades para explicar, practicar y evaluar química en secundaria
          sin comenzar desde cero.
        </span>
      </h1>

      {/* Product Visual Mockup */}
      <div className="relative w-full max-w-[320px] md:max-w-[600px] mb-0 md:mb-6" data-id="element-105">
        <img src="https://cdn.magicpatterns.com/uploads/cKv6pwz9Z5A5TMr6A1nZTf/mockup_quimica_visual.jpg" alt="MegaPack Química Visual - Tomos, fichas, evaluaciones y juegos" width={1234} height={1234} loading="eager"
      // @ts-ignore
      fetchpriority="high" decoding="async" className="w-full h-auto mix-blend-multiply" data-id="element-106" />
      </div>

      {/* Quote and Sub-headline */}
      <div className="text-center space-y-1 mb-2 md:mb-6 max-w-2xl animate-fade-in" data-id="element-107">
        <p className="text-slate-600 text-xs md:text-xl font-bold" data-id="element-108">
          5 cuadernillos completos + Biblioteca Química Visual™ + actividades
          diferenciadas + recursos docentes estratégicos.
        </p>
      </div>

      {/* CTA Button */}
      <motion.button animate={{
      boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 30px rgba(34,197,94,0.5)', '0 0 15px rgba(34,197,94,0.2)'],
      scale: [1, 1.03, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} className="w-full max-w-xs md:max-w-md bg-green-600 hover:bg-green-700 active:scale-95 text-white font-black text-lg md:text-2xl py-5 md:py-7 px-8 md:px-12 rounded-2xl shadow-[0_10px_30px_rgba(34,197,94,0.3)] flex items-center justify-center gap-3 transition-all mb-3 md:mb-4" data-id="element-109">
        <span data-id="element-110">⚗️</span>
        <span className="text-[14px]" data-id="element-111">QUIERO QUÍMICA VISUAL</span>
      </motion.button>

      {/* Guarantee Text */}
      <p className="text-[10px] md:text-sm text-slate-500 font-medium mb-4 md:mb-6 text-center" data-id="element-112">
        🔒 Garantía de satisfacción de 7 días. Si no es adecuado para ti, puedes
        solicitar la devolución.
      </p>

      {/* Trust Badges */}
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-12 text-[9px] md:text-base font-bold text-slate-500 animate-fade-in" data-id="element-113">
        <div className="flex items-center gap-2" data-id="element-114">
          <span className="text-xl" data-id="element-115">📄</span> 100% DIGITAL
        </div>
        <div className="flex items-center gap-2" data-id="element-116">
          <span className="text-xl" data-id="element-117">⚡</span> ACCESO INMEDIATO
        </div>
        <div className="flex items-center gap-2" data-id="element-118">
          <span className="text-xl" data-id="element-119">🎓</span> EDUCACIÓN SECUNDARIA
        </div>
        <div className="flex items-center gap-2" data-id="element-120">
          <span className="text-xl" data-id="element-121">🌎</span> EDICIÓN LATAM
        </div>
      </div>

      <PurchaseToast data-id="element-122" />
    </section>;
}